var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionArrowsmallLeft = function SvgGeneralActionArrowsmallLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    stroke: "#4C4C4C",
    strokeLinejoin: "round",
    d: "M14.029 18.125 7.625 12l6.404-6.125.596.637L8.887 12l5.738 5.489z"
  })));
};
export default SvgGeneralActionArrowsmallLeft;